export interface DiscretionarySessionState {
	clientId: string;
	forcedOperation: boolean;

	reportId: string;
	sessionId: string;
	sessionSummary: string;
	signature: string;
}

export const initialDiscretionarySessionState: DiscretionarySessionState = {
	reportId: '',
	clientId: '',
	sessionId: '',
	sessionSummary: '',
	signature: '',
	forcedOperation: false,
};

export enum ACTIONS {
	setState = 'setState',
	setSessionSummary = 'setSessionSummary',
	setSignature = 'setSignature',
	setForcedOperation = 'setForcedOperation',
}

export interface ActionProperties {
	payload: any;

	type: ACTIONS;
}

export const discretionarySessionReducer = (
	state: DiscretionarySessionState,
	action: ActionProperties,
): DiscretionarySessionState => {
	const { type, payload } = action;

	switch (type) {
		case ACTIONS.setState:
			return {
				...state,
				...payload,
			};
		case ACTIONS.setSessionSummary:
			return {
				...state,
				sessionSummary: payload,
			};
		case ACTIONS.setSignature:
			return {
				...state,
				signature: payload,
			};
		case ACTIONS.setForcedOperation:
			return {
				...state,
				forcedOperation: payload,
			};
		default:
			return state;
	}
};
